export const shiftsTableColumns = [
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
  },

  {
    title: 'Devices',
    dataIndex: 'device',
    key: 'device',
  },
  {
    title: 'Shift Start',
    dataIndex: 'shiftStart',
    key: 'shift start',
  },
  {
    title: 'Shift End',
    dataIndex: 'shiftEnd',
    key: 'shift end',
  },
  {
    title: 'Total Time',
    dataIndex: 'totalTime',
    key: 'total time',
  },

  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Details',
    dataIndex: 'details',
    key: 'details',
  },
  {
    title: 'Sales',
    dataIndex: 'sales',
    key: 'sales',
  },
  {
    title: 'Float Count',
    dataIndex: 'floatCount',
    key: 'float count',
  },
]
